import { Dialog, DialogContent } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getReferentielDataFromServer } from "../../../common/components/general/AxiosReferencielInterceptor";
import { AuthContext } from "../../../common/components/general/TSAuthProvider";
import { useTSData } from "../../../common/components/general/TSDataContext";
import { MESSAGING_MODE } from "../../../common/constants/generalConstants";
import TSGrid from "../../../common/components/ui/TSGrid";
import { useAuth } from "../../../common/hooks/useAuth";
import ChatMessaging from "../components/ChatMessaging";
import DeleteConversationDialog from "../components/DeleteConversationDialog";
import HistorySidebar from "../components/HistorySidebar";
import UserInfoDialog from "../components/UserInfoDialog";

const ChatMessagingPage = () => {
  const navigate = useNavigate();

  const { isAuthenticated } = useAuth();

  const {
    isMobile,
    setMode: setModeApp,
    mode: modeApp,
    openHistoriqueDialog,
    setOpenHistoriqueDialog,
    setMessageActuel,
  } = useTSData();

  const [isHistoriqueBarOpen, showHistoriqueBar] = useState(false);
  const [showUserInfoDialog, setShowUserInfoDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [sessionActive, setSessionActive] = useState(null);
  const [historyList, setHistoryList] = useState([]);
  const [mode, setMode] = useState("init");

  const { logout } = useContext(AuthContext);

  const urlParams = new URLSearchParams(window.location.search);

  const fetchConverstion = async () => {
    if (!isAuthenticated) return;
    await getReferentielDataFromServer(
      false,
      `api/user/getUserHistory`,
      {},
      "get"
    ).then((res) => {
      if (res.error) {
        if (res.status === 403) {
          logout();
          window.location.reload();
          return;
        }
        return;
      }
      setHistoryList(res);
    });
  };

  useEffect(() => {
    const handlePopState = () => {
      // Optional: Redirect manually
      navigate("/");
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  useEffect(() => {
    setMessageActuel(urlParams.get("message"));
  }, []);

  useEffect(() => {
    fetchConverstion();
  }, [isAuthenticated]);

  useEffect(() => {
    let sessionId = urlParams.get("sessionId");
    if (sessionId && isAuthenticated) setSessionActive(sessionId);
    else {
      let url = new URL(window.location.href);
      setSessionActive(null);
      url.searchParams.delete("sessionId");
      window.history.pushState({}, "", url);
    }
    setModeApp(MESSAGING_MODE);
    showHistoriqueBar(!!isAuthenticated && !isMobile);
    if (!!isAuthenticated) {
      getReferentielDataFromServer(
        false,
        `api/user/check-profile`,
        {},
        "post"
      ).then((res) => {
        if (res?.error) {
          if (res?.status === 403) {
            logout();
            window.location.reload();
          }
          return;
        }
        setShowUserInfoDialog(!res);
      });
    }
  }, [isAuthenticated]);

  const addToHistory = async (history) => {
    if (!isAuthenticated) return;
    getReferentielDataFromServer(
      false,
      "api/user/addToUserHistory",
      {
        title: history.title,
        sessionId: history.id,
      },
      "post"
    ).then((res) => {
      if (res?.error) {
        if (res?.status === 403) {
          logout();
          window.location.reload();
          return;
        }
        console.error("res", res);
        return;
      }

      fetchConverstion();
    });
  };

  const removeFromHistory = async () => {
    if (!itemToDelete) return;
    await getReferentielDataFromServer(
      false,
      `api/user/deleteUserHistory/${itemToDelete?.id}`,
      {},
      "delete"
    ).then((res) => {
      if (res?.error) {
        if (res?.status === 403) {
          logout();
          window.location.reload();
          return;
        }
        console.error("res", res);
        return;
      }
      fetchConverstion();
      setOpenDeleteDialog(false);
      setItemToDelete(null);
      setSessionActive(null);
      setMode("init");
      let url = new URL(window.location.href);
      url.hash = "";
      url.searchParams.delete("sessionId");
      window.history.pushState({}, "", url);
    });
  };

  return (
    <TSGrid container spacing={2}>
      {isHistoriqueBarOpen && (
        <>
          <TSGrid item xs={3}>
            <HistorySidebar
              setSessionActive={setSessionActive}
              setMode={setMode}
              historyList={historyList}
              setOpenDeleteDialog={setOpenDeleteDialog}
              setItemToDelete={setItemToDelete}
            />
          </TSGrid>
        </>
      )}
      <TSGrid item xs={isHistoriqueBarOpen ? 9 : 12}>
        <ChatMessaging
          isHistoriqueBarOpen={isHistoriqueBarOpen}
          sessionActive={sessionActive}
          setSessionActive={setSessionActive}
          isMobile={isMobile}
          mode={mode}
          setMode={setMode}
          addToHistory={addToHistory}
        />
      </TSGrid>
      <UserInfoDialog
        open={showUserInfoDialog}
        onClose={() => setShowUserInfoDialog(false)}
      />
      <DeleteConversationDialog
        open={openDeleteDialog}
        isMobile={isMobile}
        onClose={() => setOpenDeleteDialog(false)}
        removeFromHistory={removeFromHistory}
      />

      {isMobile && modeApp == MESSAGING_MODE && (
        <Dialog
          open={openHistoriqueDialog}
          onClose={() => setOpenHistoriqueDialog(false)}
          sx={{
            "& .MuiDialog-paper": {
              borderRadius: "30px",
              maxWidth: "550px",
            },
          }}
        >
          <DialogContent
            sx={{ padding: "0px", overflowX: "hidden", paddingBottom: "40px" }}
          >
            <HistorySidebar
              isMobile={isMobile}
              setSessionActive={(e) => {
                setSessionActive(e);
                if (isMobile) setOpenHistoriqueDialog(false);
              }}
              setMode={setMode}
              historyList={historyList}
              setOpenDeleteDialog={setOpenDeleteDialog}
              setItemToDelete={setItemToDelete}
            />
          </DialogContent>
        </Dialog>
      )}
    </TSGrid>
  );
};

export default ChatMessagingPage;
